import { atom } from "recoil";


const salesState = atom({
    key: 'currentSales',
    default: {},
});
  
export default salesState